import React, { Component } from 'react';
import styled from 'styled-components';
import Helmet from 'react-helmet';
import axios from 'axios';

import LabelledTextInput from '../components/LabelledTextInput';
import Button from '../components/Button';
import MessageSection from '../components/MessageSection';
import Notice from '../components/Notice';
import { MenuItem } from '../components/styled';

const fields = [
	{ name: 'email', placeHolder: 'EMAIL', inputWidth: 900, containerWidth: 950 },
	{ name: 'password', placeHolder: 'PASSWORD', inputWidth: 900, containerWidth: 950, type: 'password' },
];

export default class Login extends Component {
	constructor(props) {
		super(props);

		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.validateField = this.validateField.bind(this);

		let errorMessage;
		if (this.props.location.search === '?error=existing-account') {
			errorMessage = 'There is an existing account associated with this shop name and email address. Please log in to continue.';
		}

		this.state = {
			submitted: false,
			email: '',
			password: '',
			errorMessage,
		};
	}

	validateField(field, value) {
		switch(field) {
			case 'email':
				return value.length > 0;
			case 'password':
				return value.length > 0;
			default:
				return false;
		}
	}

	onChange(name) {
		return (e) => {
			e.preventDefault();
			this.setState({ errorMessage: null, [name]: e.target.value });
		}
	}

	onSubmit(e) {
		e.preventDefault();

		const errors = {};
		fields.forEach((field) => {
			if (this.validateField(field.name, this.state[field.name])) {
				delete errors[field.name];
			} else {
				errors[field.name] = true;
			}
		});
		
		if (Object.keys(errors).length > 0) {
			return this.setState({ errors });
		}

		axios.post('/api/account/login', {
			email: this.state.email,
			password: this.state.password,
		}).then(({ data }) => {
			console.log(data);
			if (!data.success) {
				if (data.error) {
					return this.setState({ errorMessage: 'Error encountered.' });
				}
			} else if (data.agent.invitationCodeActivated) {
				localStorage.setItem('id_email', this.state.email);
				localStorage.setItem('id_token', data.agent.token);
				localStorage.setItem('userExpires', data.agent.expires);
				return window.location.replace(`/account`);
			} else {
				return window.location.replace(`/activate?email=${this.state.email}&invitationCode=${data.agent.invitationCode}`);
			}
		}).catch((err) => {
			this.setState({ error: err });
		});
	}

	render () {
		return (
			<Container>
				<Helmet
					title="Activate"
					meta={[
						{ charset: 'utf-8' },
						{ name: 'viewport', content: 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no' },
						{ name: 'description', content: 'Activate' },
					]}
					link={[
						{ href: 'https://fonts.googleapis.com/css?family=Roboto+Slab|Karla', rel: 'stylesheet' },
					]}
				/>
				<HeaderContainer>
					<HeaderSection>
						<LogoContainer>
							<a href="/agent"><Image src="/images/redesign/logo.png" /></a>
						</LogoContainer>
						<div>
							<MenuContainer>
								<MenuItem><a href="/agent/faqs">FAQs</a></MenuItem>
							</MenuContainer>
						</div>
					</HeaderSection>
				</HeaderContainer>
				<div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
					{!this.state.submitted ? (
						<div>
							<MessageSection
								style={{ marginTop: '50px' }}
								header="Log into your blueshyft account"
								// paragraph1="Please confirm or enter the 12-digit code included in your invitation email"
							/>
							{this.state.errorMessage ? (
								<div style={{ display: 'flex', justifyContent: 'center', }}>
									<Notice
										color="red"
										text={this.state.errorMessage}
										width="750"
									/>
								</div>
							) : null}
						</div>
					) : (
						<MessageSection
							header="Thank you!"
							paragraph1="Your registration of interest is currently pending admin approval."
							paragraph2="Please keep an eye out for an email in the next few days which will contain next steps"
						/>
					)}
					{!this.state.submitted ? (
						<CenteredContainer>
							<InputContainer>
								{fields.map((field, key) => (
									<Column key={key} style={field.containerWidth ? { width: field.containerWidth } : {}}>
										<LabelledTextInput
											placeHolder={field.placeHolder}
											name={field.name}
											type={field.type || 'text'}
											value={this.state[field.name]}
											onChange={this.onChange(field.name)}
											style={field.inputWidth ? { width: field.inputWidth } : {}}
										/>
									</Column>
								))}
								<Column style={{ width: '946px' }}>
									<a style={{ color: '#a1aeb7', textDecoration: 'none', fontFamily: '"Karla", sans-serif;' }} href="/forgot-password">Forgot your password?</a>
								</Column>
							</InputContainer>
						</CenteredContainer>
					): null}
					{!this.state.submitted ? (
						<div>
							<Button
								text="SUBMIT"
								onSubmit={this.onSubmit} 
							/>
							<div style={{ textAlign: 'center', paddingTop: 25 }}>
								<a style={{ color: '#a1aeb7', textDecoration: 'none', fontFamily: '"Karla", sans-serif !important;' }} href="/">I am the new owner of this store.</a>
							</div>
							<div style={{ textAlign: 'center', paddingTop: 25, fontFamily: '"Karla", sans-serif !important;' }}>
								<a style={{ color: '#a1aeb7', textDecoration: 'none' }} href="/activate">Have an invitation code?</a>
							</div>
						</div>
					) : null}
				</div>
			</Container>
		);
	}
};

const InputContainer = styled.div`
	display: flex;
	width: 946px;
	justify-content: space-between;
	margin: 24px;
	flex-wrap: wrap;
`;

const CenteredContainer = styled.div`
	display: flex;
	justify-content: center;
`;

const HeaderContainer = styled.div`
	display: flex;
	justify-content: center;
	border-bottom: 1px solid #dadada;
`;

const HeaderSection = styled.div`
	display: flex;
	width: 946px;
	justify-content: space-between;
	align-items: center;
	height: 50px;
`;

const LogoContainer = styled.div`
	max-width: 120px;
`;

const MenuContainer = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	
`;

const Column = styled.div`
	width: 465px;
	margin-bottom: 20px;
`;

const Container = styled.div`
	display: flex;
	flex-direction: column;
`;

const Image = styled.img`
	display: block;
	height: auto;
	width: 100%;
`;



// WEBPACK FOOTER //
// ./client/redesign/web/Login/index.js